import { createEndpoint } from '@/shared/models/api';

export const setLastLoginDate = createEndpoint<void>(({fetch}) => () => fetch('/User/SetLastLoginDate', {
  method: 'POST',
}));